<template>
  <nav class="navi-desktop-layout-wrapper">
    <div
      id="google-one-tap-target"
      class="navi-desktop-layout"
    >
      <div class="navi-desktop-layout-left">
        <slot name="layout-left" />
      </div>
      <div class="navi-desktop-layout-right">
        <slot name="layout-right" />
      </div>
    </div>
  </nav>
</template>
<script>

export default {
  name: 'NaviDesktopLayout',
}
</script>
<style scoped lang="scss">
.navi-desktop-layout-wrapper {
  position: relative;
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #dfdfdf;
  z-index: 10;
}
.navi-desktop-layout {
  position: relative;
  display: flex;
  justify-content: space-between;
  overflow: visible;
  margin: 0px auto;
  padding: 0 1rem;
  max-width: 1024px;

  @media screen and (min-width: 80em) {
    max-width: 1280px;
  }

  :deep(ul) {
    padding: 0;

    li::marker {
      content: none;
    }
  }

  .navi-desktop-layout-left {
    display: flex;
  }
  .navi-desktop-layout-right {
    display: flex;
  }
}
</style>
